
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.071 3.515l1.414 1.414-7.071 7.07 7.071 7.072-1.414 1.414L12 13.414l-7.071 7.071-1.414-1.414L10.585 12 3.516 4.929l1.413-1.414 7.07 7.07 7.072-7.07z","fill":"#DB000D","fill-rule":"evenodd"}})])
          )
        }
      }
    